









































import { Actions } from '@/store';
import { ToastsService } from '@/utils';
import Vue from 'vue';
import { quillEditor } from 'vue-quill-editor';

export default Vue.extend({
  name: 'Feedback',
  components: {
    quillEditor,
  },
  data() {
    return {
      editorData: '',
      isFileFormatInvalid: false,
      editorOption: {
        placeholder: this.$t('feedback.editor-placeholder'),
        modules: {
          toolbar: [
            [{ size: ['small', false, 'large'] }],
            ['bold', 'italic'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['image'],
            [{ align: [] }],
          ],
        },
      },
      loader: {
        isFeedbackSending: false,
      },
    };
  },
  methods: {
    async sendData() {
      this.loader.isFeedbackSending = true;
      try {
        await this.$store.dispatch(Actions.feedback.post, {
          content: this.editorData,
        });
      } finally {
        this.editorData = '';
        ToastsService.success(this.$t('feedback.success-message') as string);
        this.loader.isFeedbackSending = false;
      }
    },
    validateImage(data: any) {
      const path = data.quill.editor.delta.ops;
      this.isFileFormatInvalid = path.some((el: any) => el.insert.image && !el.insert.image.startsWith('data:image/'));
    },
  },
});
